import { Button } from '@customerio/pluma-components/react';
import { useOpenSegmentsAddon } from '../hooks/use-open-segments-addon';
import { FlexMark } from './flex-mark';
import * as styles from './segments-addon-button.css';

/**
 * The Credits Lifecycle prototype's "Flex add-on" tag, offered at the data-driven segment cap. It is a small Pluma
 * Button because Pluma's Badge and Tag are not actions.
 */
export function SegmentsAddonButton() {
  const openSegmentsAddon = useOpenSegmentsAddon();

  return (
    <Button className={styles.flexTag} size="sm" elementBefore={<FlexMark />} onClick={() => void openSegmentsAddon()}>
      Flex add-on
    </Button>
  );
}
